import {BaseApi} from '../shared/api';
import {startLoading, stopLoading} from '../shared/actions';
import {push} from 'react-router-redux';
import * as types from './actionTypes';
import * as urls from './apiUrls';

// remove me later and use BaseApi
import Cookies from 'universal-cookie';
import fetchWithProgress from '../../utils/FetchWithProgress';

const cookies = new Cookies();

function financialTrustPassHydrate(data) {
  return {type: types.FINANCIAL_TRUSTPASS_HYDRATE, payload: data};
}

function receiveTrustPass(data) {
  return {type: types.RECEIVE_FINANCIAL_TRUSTPASS, payload: data};
}

export function creditBoostUpdate(count) {
  return {
    type: types.CREDIT_BOOST_UPDATE,
    payload: count,
  };
}

export function submitFinancialTrustpass() {
  return dispatch => {
    dispatch({type: 'CREDIT_BOOST_UPDATE'});
  };
}

export function fetchFinancialTrustpass(urlProps = {}, callback = () => {}) {
  return (dispatch, getState) => {
    const {user, company} = getState();
    if (!user || !company) return;
    return fetch(urls.apiV2FinancialTrustpassUrl(user.id, company.id), {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: cookies.get('jwtToken'),
      }),
    })
      .then(response => response.json())
      .then(json => {
        dispatch({
          type: types.RECEIVE_FINANCIAL_TRUSTPASS,
          payload: json,
        });
        callback && callback(json);
      })
      .catch(error => {
        dispatch({
          type: 'HANDLE_ERRORS',
          payload: error,
        });
        dispatch({type: 'LOADING_STOP'});
      });
  };
}

export function fetchFinancialTrustpassDocument(urlProps, callback) {
  const {userId, companyId, docId} = urlProps;

  return dispatch => {
    return fetch(
      urls.apiV2FinancialTrustpassDocumentUrl(userId, companyId, docId),
      {
        method: 'GET',
        headers: new Headers({
          Authorization: cookies.get('jwtToken'),
        }),
      },
    )
      .then(response => response.json())
      .then(json => {
        dispatch({
          type: types.RECEIVE_FINANCIAL_TRUSTPASS_DOCUMENT,
          payload: json,
        });
        callback(json);
      })
      .catch(error => {
        dispatch({
          type: 'HANDLE_ERRORS',
          payload: error,
        });
        dispatch({type: 'LOADING_STOP'});
      });
  };
}

export function createFinancialTrustpassDocument(
  urlProps,
  body,
  onProgress,
  callback,
) {
  const {userId, companyId} = urlProps;

  return dispatch => {
    return fetchWithProgress(
      urls.apiV2FinancialTrustpassDocumentsUrl(userId, companyId),
      {
        method: 'POST',
        headers: {Authorization: cookies.get('jwtToken')},
        body: body,
      },
      onProgress,
    )
      .then(json => {
        const parsedResponse = JSON.parse(json);
        dispatch({
          type: types.RECEIVE_FINANCIAL_TRUSTPASS_DOCUMENT,
          payload: parsedResponse,
        });

        callback(parsedResponse);
      })
      .catch(error => {
        dispatch({
          type: 'HANDLE_ERRORS',
          payload: error,
        });
        dispatch({type: 'LOADING_STOP'});
      });
  };
}

export function updateFinancialTrustpassDocument(
  urlProps,
  body,
  onProgress,
  callback,
) {
  const {userId, companyId, docId} = urlProps;

  return dispatch => {
    return fetchWithProgress(
      urls.apiV2FinancialTrustpassDocumentUrl(userId, companyId, docId),
      {
        method: 'PUT',
        headers: {Authorization: cookies.get('jwtToken')},
        body: body,
      },
      onProgress,
    )
      .then(json => {
        const parsedResponse = JSON.parse(json);
        dispatch({
          type: types.UPDATE_FINANCIAL_TRUSTPASS_DOCUMENT,
          payload: parsedResponse,
        });

        callback(parsedResponse);
      })
      .catch(error => {
        console.error(error);
      });
  };
}

export function createDocument(data, onSuccess, prevPage = null) {
  return (dispatch, getState) => {
    dispatch(startLoading());

    const api = new BaseApi(dispatch, getState);
    const {user, company} = getState();
    return api.postRequest(
      urls.financialTrustPassDocument(user.id, company.id),
      data,
      response => {
        onSuccess(response.data);
        dispatch(receiveTrustPass(response.data));
        dispatch(stopLoading());

        switch (prevPage) {
          case 'onboarding':
            return dispatch(push('/requirements'));
          case 'creditLimitIntro':
            return;
          default:
            return dispatch(push('/credit-boost'));
        }
      },
    );
  };
}

export function hydrateFinancialTrustPass(data, onSuccess) {
  return (dispatch, getState) => {
    dispatch(startLoading());

    const api = new BaseApi(dispatch, getState);
    const {user, company} = getState();
    return api.putRequest(
      urls.financialTrustPass(user.id, company.id),
      data,
      response => {
        dispatch(financialTrustPassHydrate(response.data));
        onSuccess(response);
        dispatch(stopLoading());
      },
    );
  };
}



// WEBPACK FOOTER //
// ./src/features/financial-trustpass/actions.js